import React from 'react'
import PropTypes from 'prop-types'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import IconTitle from '../IconTitle'
import CustomButton from '../CustomButton'
import './style.sass'

const SectionHeader = ({
  title,
  subTitle,
  mainButtonText,
  mainButtonOnClick,
  mainButtonDisabled,
  mainButtonClass,
  mainButtonToolTip,
  backButtonText,
  backButtonOnClick,
  status
}) => {

  const renderStatus = () => {
    if (!status) return null

    switch (status) {
      case "Draft":
      case "Updated":
        return <IconTitle title={status} icon="clock-o" iconClass="icon-primary" />
      case "In review":
      case "Not Published":
        return <IconTitle title={status} icon="clock-o" iconClass="icon-warning" />
      case "Active":
      case "Approved":
      case "Live":
        return <IconTitle title={status} icon="check-circle-o" iconClass="icon-success" />
      case "Rejected":
      case "Canceled":
        return <IconTitle title={status} icon="times-circle-o" iconClass="icon-error" />
      case "Expired":
        return <IconTitle title={status} icon="times-circle-o" iconClass="icon-warning" />
      default:
        return null
    }
  }

  const renderMainButton = () => {
    if (mainButtonToolTip) {
      return (
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id="tooltip-top">{mainButtonToolTip}</Tooltip>}
        >
          <CustomButton
            onClick={mainButtonOnClick}
            buttonText={mainButtonText || "Next"}
            className={`btn btn-fill ${mainButtonClass}`}
            disabled={mainButtonDisabled}
          />
        </OverlayTrigger>
      )
    }
    return (
      <CustomButton
        onClick={mainButtonOnClick}
        buttonText={mainButtonText || "Next"}
        className={`btn btn-fill ${mainButtonClass}`}
        disabled={mainButtonDisabled}
      />
    )
  }

  const renderTitle = () => {
    if (title?.length > 25) {
      return (
        <OverlayTrigger
          placement="bottom"
          overlay={<Tooltip id="tooltip-bottom">{title}</Tooltip>}
        >
          <h3>{title} </h3>
        </OverlayTrigger>
      )
    }
    return <h3>{title} </h3>
  }

  return (
    <header className="section-header-container">
      <div className="navigation-container">
        {!backButtonOnClick || (
          <a onClick={backButtonOnClick}><i className="fa fa-chevron-left" />{backButtonText || "Back"}</a>
        )}
      </div>
      <div className="title-container">
        <div className="title-inner-container">
          <div className="title-text-and-status-container">
            {renderTitle()} {renderStatus()}
          </div>
          {!subTitle || <h6>{subTitle}</h6>}
        </div>
        {!mainButtonOnClick || renderMainButton()}
      </div>
    </header>
  )
}

SectionHeader.propTypes = {
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string,
  mainButtonText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  mainButtonOnClick: PropTypes.func,
  mainButtonDisabled: PropTypes.bool,
  mainButtonClass: PropTypes.string,
  mainButtonToolTip: PropTypes.string,
  backButtonText: PropTypes.string,
  backButtonOnClick: PropTypes.func,
  status: PropTypes.oneOf(["Draft", "Active", "In review", "Approved", "Rejected", "Live", "Expired", "Canceled", "Not Published", "Updated"])
}

export default SectionHeader
